import DHowSpit from './DHowSpit'

export default DHowSpit
